import { useState, useEffect, useRef } from "react";
import { point, destination } from "@turf/turf";

export function useMapBounds(map, n = 0.4) {
  const [bounds, setBounds] = useState(null);


  useEffect(() => {
    if (!map) return;


    const updateBounds = () => {


      // 地図の中心緯度経度を取得
      const center = map.getCenter();

      // マップの描画範囲のバウンディングボックスを取得
      const mapBounds = map.getBounds();

      // 地図の幅と高さ（緯度経度）を計算
      const mapWidth = Math.abs(mapBounds.getEast() - mapBounds.getWest());
      const mapHeight = Math.abs(mapBounds.getNorth() - mapBounds.getSouth());

      // 中心から指定された割合（n）だけ距離を伸ばす
      const distanceEastWest = mapWidth * n;
      const distanceNorthSouth = mapHeight * n;

      const centerPoint = point([center.lng, center.lat]);
      const eastPoint = destination(centerPoint, distanceEastWest / 2, 90, { units: "degrees" }).geometry.coordinates;
      const westPoint = destination(centerPoint, distanceEastWest / 2, -90, { units: "degrees" }).geometry.coordinates;
      const northPoint = destination(centerPoint, distanceNorthSouth / 2, 0, { units: "degrees" }).geometry.coordinates;
      const southPoint = destination(centerPoint, distanceNorthSouth / 2, 180, { units: "degrees" }).geometry.coordinates;

      // 新しいバウンディングボックスを定義
      const newBounds = {
        minLng: westPoint[0],
        minLat: southPoint[1],
        maxLng: eastPoint[0],
        maxLat: northPoint[1],
      };

      setBounds(newBounds);

      
    };

    // 初回実行
    updateBounds();

    // 地図の移動が終了したときにバウンディングボックスを更新
    map.on("moveend", updateBounds);

    return () => {
      map.off("moveend", updateBounds);
      
    };
  }, [map, n]);

  return bounds;
}
